<template>
  <div class="container">
    <div class="columns">
      <div class="column col-8 col-md-12">
        <div class="bg-secondary text-center">
          <p>Visa Entitlement Verification Online - check visa details and conditions.</p>
        </div>
        <label class="form-label text-bold">Family name</label>
        <input class="form-input" type="text" v-model="familyName" />
          
        <label class="form-label text-bold">Given name(s)</label>
        <input class="form-input" type="text" v-model="givenName" />

        <label class="form-label text-bold">Date of birth</label>
        <div class="input-group">
          <div class="columns">
            <div class="column col-2 col-sm-3"><input class="form-input" type="number" v-model="dob_d" placeholder="DD" /></div>
            <div class="column col-2 col-sm-3"><input class="form-input" type="number" v-model="dob_m" placeholder="MM" /></div>
            <div class="column col-3 col-sm-6"><input class="form-input" type="number" v-model="dob_y" placeholder="YYYY" /></div>
          </div>
        </div>


        <label class="form-label text-bold">Passport Number</label>
        <input class="form-input" type="text" v-model="docNumber" />

        <label class="form-label text-bold">Document country</label>

        <select class="form-select" v-model="docCountry">
          <option v-for="(v,k) in countries" :value="v">{{k}}</option>
        </select>

        <button @click="submit" class="btn btn-primary" :class="{loading: loading}">Submit</button>
      
      </div>

    </form>

    <br/>
    <div class="column col-8 col-md-12">
      <div class="card" v-if="results && results.success">
        <div class="card-header">
          <div class="card-title h5">Results</div>
          <div class="card-body">

            <div class="columns" v-for="(desc, field) in resultFields">
              <div v-if="results[field]" class="col-3 col-sm-12">{{desc}}</div>
              <div v-if="results[field]" class="col-9 col-sm-12">{{results[field]}}</div>
            </div>

            <div class="columns" v-if="results.conditions">
              <div class="col-3 col-sm-12">Visa conditions</div>
              <div class="col-9 col-sm-12">
                <div v-for="c in results.conditions" v-html="c"></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <span v-if="results && results.message" class="label label-error">{{results.message}}</span>
      <span v-if="errormsg" class="label label-error">{{errormsg}}</span>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'

export default {
  name: 'vevo',
  mixins: [utils],
  data () {
    return {
      countries: utils.countries(),
      resultFields: utils.vevoFields(),
      showDateModal: false,
      loading: false,
      results: null,
      errormsg: null,
      familyName: '',
      givenName: '',
      dob_y: '',
      dob_m: '',
      dob_d: '',
      docType: '01', // PASSPORT
      docNumber: '',
      docCountry: ''
    }
  },
  created: function () {
    this.$root.$data.pageTitle = 'VEVO'
  },
  methods: {
    submit () {
      if (this.loading) return
      this.loading = true
      this.errormsg = null
      const params = new URLSearchParams()

      params.append('dyb_password', process.env.DYB_PASSWORD)
      params.append('familyName', this.familyName)
      params.append('givenName', this.givenName)
      params.append('dob', [this.dob_y, this.dob_m, this.dob_d].join('-'))
      params.append('docType', this.docType)
      params.append('docNumber', this.docNumber)
      params.append('docCountry', this.docCountry)

      axios.get(utils.dybURL() + params.toString())
      .then(res => {
        if (res.status === 200) {
          this.loading = false
          this.results = res.data
        }
      })
      .catch(e => {
        this.loading = false
        this.errormsg = e.response.data
      })
    },
    testFunc () {
      axios.get('/api/agreements/test')
      .catch(e => { console.log(e.response.data) })
    }
  }
}
</script>
<style scoped>
.card {
  border: 1px solid rgb(19, 110, 251,0.3);
  border-radius: 2px;
  padding: 1em;
  margin: 2em 0;
  background: rgba(63, 169, 245, 0.15)
}
.card a {
  color: #136efb
}
.btn.btn-primary {
  margin: 2em 0;
  width: 30%;
  height: 2.3rem;
}
.bg-secondary {
  border: 1px solid rgb(19, 110, 251,0.3);
  border-radius: 2px;
  padding: 1em;
  margin: 2em 0;
  background: rgba(63, 169, 245, 0.15);
}
.bg-secondary p {
  color: #136efb;
  margin:0;
}
</style>



// WEBPACK FOOTER //
// vevo.vue?10ece61c